/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.





  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


// Header menu on hover add class ------------ start 

let secondLevelMenus = document.querySelectorAll('.js-button');

secondLevelMenus.forEach(menu => {
  menu.addEventListener('mouseover', function() {
    secondLevelMenus.forEach(menu => {
      menu.closest('.js-second-level-menu').classList.remove('active');
    });
    this.closest('.js-second-level-menu').classList.add('active');
    
    let levelTwoMenuName = this.querySelector('.js-lvl-2-menu-name').textContent;
    let thirdLevelMenu = document.querySelectorAll('.js-third-level-menu');
    
    thirdLevelMenu.forEach(menu => {
      if(menu.getAttribute('menu-title') === levelTwoMenuName ){
        menu.classList.add('active');
      }else{
        menu.classList.remove('active');
      }
    })
  });
});


// Header menu on hover add class ------------ end

// PDP wholesale price update
{
  const intervalId = setInterval(() => {
    let quantityInput = document.querySelector('.waio_qty-input .input_moq');
    if(!quantityInput) return;
    clearInterval(intervalId);
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }, 1000);
  
  setTimeout(() => {
    clearInterval(intervalId);
  }, 10000);
}